<template>
  <div id="createMerge">
    <div class="o-modal">
      <div class="o-modal-content">
        <div class="o-modal-header">
          <a
            @click="$store.commit('dataJoiner/setStateProperty', { property: 'showCreateMerge', value: false })"
            class="close clickable"
          ><i class="far fa-times"></i></a>
          <p class="lead" v-if="!editMode">Create Merge</p>
          <p class="lead" v-else>Edit Merge {{ $store.state.dataJoiner.mergeIndex + 1 }}</p>
        </div><!-- /.o-modal-header -->
        <div class="o-modal-body">
          <!-- <label><strong>Choose Dataset</strong></label>
          <b-form-select
            v-model="tempMerge.dataset"
            :options="$store.state.dataJoiner.chosenDatasets"
            text-field="name"
            value-field="name"
            @change="chooseDataset($event)"
          ></b-form-select>
          <div class="mt-2" v-if="tempMerge.dataset.length > 0">
            <label><strong>Choose Header</strong></label>
            <b-form-select
              v-model="tempMerge.header"
              :options="tempMerge.headers"
              text-field="name"
              @change="chooseHeader()"
            ></b-form-select> -->
          <div class="mt-2">
            <label><strong>New Header Name</strong></label>
            <b-form-input
              v-model="tempMerge.name"
              class="mb-3"
            ></b-form-input>

            <label><strong>Current Headers to Merge</strong><br><small>(Order establishes Hierarchy)</small></label>
            <div class="row">
              <div class="col-6">
                <label class="text-center w-100">Choose Headers</label>
                <div
                  v-for="(option, i) in mergeInOptions"
                  v-bind:key="i"
                  @click="selectMergeInOption(i)"
                  class="list-group-item clickable"
                >
                  <i class="fas fa-plus-circle text-success"></i> {{ option.dataset +  ' - ' + option.header }}
                </div>
              </div><!-- /.col-6 -->
              <div class="col-6">
                <label class="text-center w-100">To Merge</label>
                <div
                  v-for="(mergeInDataset, me) in tempMerge.merges"
                  v-bind:key="me"
                  class="list-group-item"
                  active
                >
                  <i class="fas fa-minus-circle text-danger clickable" @click="removeMergeInDataset(me)"></i> {{ mergeInDataset.dataset + ' - ' + mergeInDataset.header }}
                </div><!-- /.list-group-item -->
              </div><!-- /.col-6 -->
            </div><!-- /.row -->
          </div>
        </div><!-- /.o-modal-body -->
        <div class="o-modal-footer">
          <div class="float-right">
            <button
              v-if="!editMode && tempMerge.name.length > 0 && tempMerge.merges.length > 1"
              @click="addMerge()"
              class="btn btn-primary mr-1"
            >
              Add Merge
            </button>
            <button
              v-if="editMode && tempMerge.name.length > 0 && tempMerge.merges.length > 1"
              @click="updateMerge()"
              class="btn btn-primary mr-1"
            >
              Update Merge
            </button>
          </div><!-- /.float-right -->
        </div><!-- /.o-modal-footer -->
      </div><!-- /.o-modal-content -->
    </div><!-- /.o-modal -->
  </div><!-- /#createMerge -->
</template>

<script>
export default {
  data () {
    return {
      tempMerge: {
        name: 'New Header',
        merges: []
      },
      mergeInOptions: []
    }
  },
  computed: {
    merge: {
      get () {
        return this.$store.state.dataJoiner.merge
      },
      set (value) {
        this.$store.commit('dataJoiner/setStateProperty', { property: 'merge', value: value })
      }
    },
    merges: {
      get () {
        return this.$store.state.dataJoiner.merges
      },
      set (value) {
        this.$store.commit('dataJoiner/setStateProperty', { property: 'merges', value: value })
      }
    },
    editMode: {
      get () {
        return this.$store.state.dataJoiner.editMode
      },
      set (value) {
        this.$store.commit('dataJoiner/setStateProperty', { property: 'editMode', value: value })
      }
    },
    showCreateMerge: {
      get () {
        return this.$store.state.dataJoiner.showCreateMerge
      },
      set (value) {
        this.$store.commit('dataJoiner/setStateProperty', { property: 'showCreateMerge', value: value })
      }
    }
  },
  created () {
    this.$store.state.dataJoiner.chosenDatasets.forEach(dataset => {
      dataset.headers.forEach(header => {
        this.mergeInOptions.push({
          dataset: dataset.name,
          header: header
        })
      })
    })
    if (this.editMode) {
      this.tempMerge = JSON.parse(JSON.stringify(this.merge))
      this.mergeInOptions = []
      this.$store.state.dataJoiner.chosenDatasets.forEach(dataset => {
        dataset.headers.forEach(header => {
          let alreadyChosen = false
          this.tempMerge.merges.forEach(set => {
            if (set.dataset === dataset.name && set.header === header) {
              alreadyChosen = true
            }
          })
          if (!alreadyChosen) {
            this.mergeInOptions.push({
              dataset: dataset.name,
              header: header
            })
          }
        })
      })
    }
  },
  methods: {
    removeMergeInDataset (me) {
      this.mergeInOptions.push(this.tempMerge.merges[me])
      this.tempMerge.merges.splice(me, 1)
    },
    selectMergeInOption (i) {
      this.tempMerge.merges.push(this.mergeInOptions[i])
      this.mergeInOptions.splice(i, 1)
    },
    // chooseDataset (e) {
    //   this.tempMerge.headers = []
    //   this.tempMerge.header = ''
    //   this.$store.state.dataJoiner.chosenDatasets.forEach(dataset => {
    //     if (dataset.name === e) {
    //       this.tempMerge.headers = dataset.headers
    //     }
    //   })
    // },
    // chooseHeader () {
    //   this.mergeInOptions = []
    //   this.$store.state.dataJoiner.chosenDatasets.forEach(dataset => {
    //     dataset.headers.forEach(header => {
    //       if (dataset.name !== this.tempMerge.dataset) {
    //         this.mergeInOptions.push({
    //           dataset: dataset.name,
    //           header: header
    //         })
    //       }
    //     })
    //   })
    //   console.log(this.mergeInOptions)
    // },
    addMerge () {
      if (this.tempMerge.name.length > 0 && this.tempMerge.merges.length > 1) {
        this.merges.push(this.tempMerge)
        this.showCreateMerge = false
      }
    },
    updateMerge () {
      if (this.tempMerge.name.length > 0 && this.tempMerge.merges.length > 1) {
        const mergeIndex = this.$store.state.dataJoiner.mergeIndex
        this.merges[mergeIndex] = this.tempMerge
        this.showCreateMerge = false
      }
    }
  }
}
</script>
